module.exports = __webpack_public_path__ + "img/pencil.be5030ca.webp";